const PROVEEDOR = 'EDigital';

const ambits = {
  managedment: 'unidad',
  profile: 'perfil'
};

const certStatus = {
  ACTIVE: true,
  INACTIVE: false
};

const documentTypes = [
  { id: 'CEDULA', nombre: 'Cedula chilena' },
  { id: 'CEDULA_EXT', nombre: 'Cedula extranjera' }
];

const genderOptions = [
  { id: 'male', nombre: 'Masculino' },
  { id: 'female', nombre: 'Femenino' }
];

export {
  PROVEEDOR,
  ambits,
  certStatus,
  documentTypes,
  genderOptions
};
